import { render, staticRenderFns } from "./school_login.vue?vue&type=template&id=26112afe&scoped=true&"
import script from "./school_login.vue?vue&type=script&lang=js&"
export * from "./school_login.vue?vue&type=script&lang=js&"
import style0 from "./school_login.vue?vue&type=style&index=0&id=26112afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26112afe",
  null
  
)

export default component.exports